import { WGS84_WKT_MARKERS } from './constants';

// Terse classifier: scan the WKT PRJ content for any of the tokens that are
// unambiguous signals of WGS84. We intentionally avoid a WKT parser —
// shapefile producers in agriculture consistently include at least one of
// these substrings and false positives on "WGS 84" inside some other
// context are essentially impossible.
export const detectCrs = ({ prj }: { prj: string }): 'WGS84' | { unsupported: string } => {
    const normalized = prj.replace(/\s+/g, ' ').trim();

    for (const marker of WGS84_WKT_MARKERS) {
        if (normalized.includes(marker)) {
            return 'WGS84';
        }
    }

    // Attempt to extract the first quoted GEOGCS / PROJCS name as the
    // "detected" value so the error surface names what the shapefile is in.
    const projectionNameMatch = /PROJCS\["([^"]+)"/.exec(normalized);
    const geographicNameMatch = /GEOGCS\["([^"]+)"/.exec(normalized);
    const detected = projectionNameMatch?.[1] ?? geographicNameMatch?.[1] ?? 'unknown projection';

    return { unsupported: detected };
};
